import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import ApiService from '../../../services/ApiService';
import GetContract from './getContract/getContract';
import AcceptInput from '../../chooseUserBuy/accept/accept';
import CustomLink from '../../../components/Elements/Link/link';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import AppContractsRefresh from '../../../components/AppContractsRefresh';
import AppContractAnnex from '../../../components/AppContractAnnex';
import AppContractSchedule from '../../../components/AppContractSchedule';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import "./contract.css"
import CourseDetail from '../../coursDetail/courseDetail';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import axios from 'axios';
import { API_URL } from '../../../config';
import ComplateData from '../VariantSummary/complateData.js'

let idLoader;
 
const Contract = (props) => {
    const [isFullData, setIsFullData] = useState(true)
    const history = useHistory();
    let parcipientName =  localStorage.getItem('userName');   
    if(parcipientName == null){
        parcipientName =  localStorage.getItem('payerName');    
    }

    let parcipientNameDataCheck = JSON.parse( localStorage.getItem('selectedPartipient'));
    const userDataCheck = JSON.parse( localStorage.getItem('users'));
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    let parcipientUser =localStorage.getItem('selectedPartipient');
    let adultPersonForUser = JSON.parse(localStorage.getItem('selectedPayers'));
    const apiService = ApiService.getInstance();
    if(parcipientUser != "undefined"){
        parcipientUser= JSON.parse(localStorage.getItem('selectedPartipient'));} 
    const courseHeadingFull = JSON.parse(localStorage.getItem('courseHeadingFull'));
    const users =  JSON.parse(localStorage.getItem('users'));
    let key = localStorage.getItem('keyURL')
    let userID = localStorage.getItem('usersID')
    let usersParticipant = "";
    let amountZero = {
        installmentZero: 0,
        amountZero: 0,
        monthInstalment: 0 
    };
    const [consent, setConsent] =  useState({
        term: false,
        statue: false,
      
    })
    const [markieingConsent, setMarkieingConsent] =  useState({
        marketingAgreement: false,
        consentReceiveSmsEmailPhone: false,
      
    })
    const [isConsent, setIsConsent] =  useState(true)
 
    const [allInstallmentsPrice, setAllInstallmentsPrice]=useState(0)
    const[showContract, setShowContract] = useState(true)
    const[showAnex, setShowAnex] = useState(true);
    const[showSchelude, setShowSchelude] = useState(true)
    const proxySendURL = `${API_URL}ProxySend`


 if(isFullData&&(!parcipientUser||!adultPersonForUser)){
     
        if(userDataCheck.city.length == 0||userDataCheck.genderDVID == 0||userDataCheck.building.length == 0||userDataCheck.firstName.length == 0||userDataCheck.lastName.length == 0||userDataCheck.pesel.length == 0||userDataCheck.postalCode.length == 0||userDataCheck.street.length == 0||userDataCheck.dateOfBirdth === "01/01/0001 00:00:00"){
        setIsFullData(false)}
        
    }
    if(isFullData&&parcipientNameDataCheck!= null){
       
        if(parcipientNameDataCheck.city.length == 0||parcipientNameDataCheck.genderDVID == 0||parcipientNameDataCheck.building.length == 0||parcipientNameDataCheck.firstName.length == 0||parcipientNameDataCheck.lastName.length == 0||parcipientNameDataCheck.pesel.length == 0||parcipientNameDataCheck.postalCode.length == 0||parcipientNameDataCheck.street.length == 0||parcipientNameDataCheck.dateOfBirdth === "01/01/0001 00:00:00"){
        setIsFullData(false)}
        
    }if(isFullData&&adultPersonForUser!= null){
   
        if(adultPersonForUser.city.length == 0||adultPersonForUser.genderDVID == 0||adultPersonForUser.building.length == 0||adultPersonForUser.firstName.length == 0||adultPersonForUser.lastName.length == 0||adultPersonForUser.pesel.length == 0||adultPersonForUser.postalCode.length == 0||adultPersonForUser.street.length == 0||adultPersonForUser.dateOfBirdth === "01/01/0001 00:00:00"){
        setIsFullData(false)}
        
    }



    const startLoaderTask = (taskConfig = null) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.startTask === 'function'
        ) {
            return window.edsLoader.startTask(taskConfig);
        } else {
            return false;
        }
    };
    const stopLoaderTask = (taskId) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.endTask === 'function'
        ) {
            return window.edsLoader.endTask(taskId);
        } else {
            return false;
        }
    };
  
    function registerClick(){
        if( consent.statue&&consent.term){
            let consent = {
                usersID: users.usersID,
                marketingAgreement: markieingConsent.marketingAgreement,
                consentReceiveSmsEmailPhone: markieingConsent.consentReceiveSmsEmailPhone,
            };
       
            apiService.apiPost(
                'UpdateUserConsents',
                consent,
                (response) => {
                    
                },
                false
            );
        props.next()}else{
            setIsConsent(false)
        }
    }
    if( consent.statue&&consent.term&&!isConsent){
        setIsConsent(true)
    }
    for(var i = 0; i < props.data.installment?.length; i++){

        if(props.data.listOfInstallment[0]==props.data.installment[i].countNumber){
            amountZero = {
                installmentZero: props.data.installment[i].paymentPositionPrice,
                amountZero: props.data.installment[i].paymentPositionPrice,
                monthInstalment: amountZero.monthInstalment
            };
          
        }else{
            amountZero = {
                installmentZero: amountZero.installmentZero,
                amountZero: amountZero.amountZero,
                monthInstalment: props.data.installment[i].paymentPositionPrice,
            };
        }
        if(props.data.entryFee != null){
            amountZero.amountZero += +props.data.entryFee
        }
    }
    let paymentPositionPrice = 0;
    let paymentPositionPriceDiscount = 0

    if(parcipientUser != null){
    if(parcipientUser.usersID != users.usersID){
        usersParticipant = parcipientUser
    }}
    for(var i =0;i< props.data.installment?.length;i++){
        if(props.data.listOfInstallment.includes(props.data.installment[i].countNumber)){
             paymentPositionPriceDiscount += props.data.installment[i].paymentPositionPriceDiscount
             paymentPositionPrice += props.data.installment[i].paymentPositionPrice

        }
    }
    let installemntPrice = 0

    useEffect(()=>
    {
        for(var i = 0; i < props.data.installment?.length; i++){
        installemntPrice += props.data.installment[i].paymentPositionPriceDiscount
    

    if(i == props.data.installment.length - 1){setAllInstallmentsPrice(installemntPrice)}
}
    
}, [])


    return <> 
    {isFullData?
    <div className='contracts_content'>
    <div className={showContract?'contracts_wrapper':'dont_Display'}>
        <div className='contract_content'>
    <CustomTittle>Poniżej znajdziesz umowy do pobrania</CustomTittle>
        <div className='contracts_area'>
            {props.discountD!=0&&props.data.getGroup.paymentTypesDVID!=1?<div className='rowContract'>    
                <div className="rowContractLine">
                    <GetContract titlePDF='Wzór UmowaEDS' elementID="elem" showContract={setShowContract}>Umowa Lorem ipsuma</GetContract>
                    <GetContract titlePDF='Rabat' elementID="elem2" showContract={setShowAnex}>Umowa Lorem ipsuma</GetContract>
                </div>
                <GetContract titlePDF='Wzór Harmonogram' elementID="elem3" showContract={setShowSchelude}>Umowa Lorem ipsuma</GetContract>
            </div>:""}
           { props.discountD==0&&props.data.getGroup.paymentTypesDVID!=1?<div className='rowContract'>    
                <div className="rowContractLine">
                    <GetContract titlePDF='Wzór umowaEDS' elementID="elem" showContract={setShowContract}>Umowa Lorem ipsuma</GetContract>
                    <GetContract titlePDF='Wzór harmonogram' elementID="elem3" showContract={setShowSchelude}>Umowa Lorem ipsuma</GetContract>
                </div>
                
            </div>:""}
            { props.discountD!=0&&props.data.getGroup.paymentTypesDVID==1?<div className='rowContract'>    
                <div className="rowContractLine">
                    <GetContract titlePDF='Wzór umowaEDS' elementID="elem" showContract={setShowContract}>Umowa Lorem ipsuma</GetContract>
                    <GetContract titlePDF='Wzór Rabat' elementID="elem2" showContract={setShowAnex}>Umowa Lorem ipsuma</GetContract>
                </div>
                
            </div>:""}
            { props.discountD==0&&props.data.getGroup.paymentTypesDVID==1?<div className='rowContract'>    
                <div className="rowContractLine">
                    <GetContract titlePDF='UmowaEDS' elementID="elem" showContract={setShowContract}>Umowa Lorem ipsuma</GetContract>
                   
                </div>
                
            </div>:""}
        </div>
    <p className='acceptContract_tittle'>Przeczytaj je, a następnie zaakceptuj zgody:</p>
        <div className='acceptContract'>
            <div className='acceptrContractLabel'><AcceptInput  onAccept={(e) => {setConsent({...consent,...{term: !e}},); setIsConsent(true) }} label="* Akceptuję warunki umowy"></AcceptInput></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setConsent({...consent,...{statue: !e}},); setIsConsent(true) }} label="* Akceptuję"></AcceptInput><CustomLink link="/Statue">Regulamin</CustomLink></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setMarkieingConsent({...markieingConsent,...{consentReceiveSmsEmailPhone: !e}},);}} label="Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych drogą elektroniczną, za pośrednictwem automatycznych systemów wywołujących oraz telefonicznie z wykorzystaniem telekomunikacyjnych urządzeń końcowych."></AcceptInput></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setMarkieingConsent({...markieingConsent,...{marketingAgreement: !e}});}} label="Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych promujących towary i usługi Administratora, a także w celach promujących towary i usługi partnerów, których lista dostępna jest pod adresem strony www.egurrola.com/partnerzy/."></AcceptInput></div>
            {!isConsent?<p className="needToByAccept">* Zakceptuj zgody</p>:""}
        </div>
        <CustomButtons clickFunction={registerClick} size="big" classButton="solid">POTWIERDZAM ZAWARCIE UMOWY</CustomButtons>
  
    </div>
    </div>
    <div className={showContract?'columDetials':'dont_Display'}>
            <div className={showContract?'columDetials_wrapper contractMarginWraper':'columDetials_wrapper'} >
                        <CustomTittle>Szczegóły zamówienia  </CustomTittle>
                        <CourseDetail  wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
                        <UserDetailPopUp onclick={()=>{props.setNavigator(1,"chooseUser")}}title="Uczestnik:" label={parcipientName} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                <UserDetailPopUp onclick={()=>{props.setNavigator(2,"data")}} title="Data rozpoczęcia:" label={props.start.split("-")[2] +"-"+ props.start.split("-")[1] +"-"+ props.start.split("-")[0]} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                <UserDetailPopUp onclick={()=>{props.setNavigator(3,"variant")}} title="Wariant cenowy:" hint={props.data.varaintHint} label={props.data.variantTittle} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                {props.discountD.length !=0?<UserDetailPopUp onclick={()=>{props.setNavigator(4,"payment")}} title="Kod rabatowy:"  label={"-"+props.discountD.discountValue+"%"} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>:""}
                <div className='contractSummary'>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Wartość:</p> <p className='contractSummary_value'>{props.data.summary.value} zł</p></div>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Opłata Wpisowa:</p><p className='contractSummary_value' >{props.data.summary.entryFee} zł</p></div>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Rabat:</p> <p className='contractSummary_value'>-{props.data.summary.discount} zł</p></div>             
                    <div className='contractSummary_summaryValue'><CustomTittle>DO ZAPŁATY:</CustomTittle> <CustomTittle>{props.data.summary.summary} zł</CustomTittle></div>             
                    <p className='amountInstallment'>   { }</p>      
                </div>
            </div>
        </div>
        <div className={showContract?'dont_Display':""} id='elem'>
         <AppContractsRefresh
                                getGroup={props.data.getGroup} 
                                paymentDVIDName={props.data.paymentType}
                                payForm={{selectedPaymentMethod:props.data.payForm,
                                    selectedCard:null,}} 
                                dateToBay={props.start} 
                                users={users} 
                                usersParticipant={usersParticipant}
                                coursesHeadings={courseHeadingFull}

                                 allInstallmentsPrice={props.data.getGroup.currentPrice}
                                 allInstallments={props.data.installment}
                                 numberOfinstallments={props.data.installment?.length}
                                 selectedInstallments={props.data.listOfInstallment}

                                payZero={amountZero}
                                 entryFee={{
                                  discountCash:0,
                                    discountProcent: 0,
                                    paymentData: props.start,
                                    priceCash:props.data.entryFee,
                                    priceDiscount: props.data.entryFee,

                                }}
                                
                                
                                
                                
                                 promotionsData={{promotionId:props.data.promotionData.selectedPromotions,
                                combinedPromotionIDs:[]}}
 
                            />
                           
                           </div>
<div className={showAnex?'dont_Display':""} id='elem2'>
                            <AppContractAnnex
                                 getGroup={props.data.getGroup}
                                 
                                 payForm={{selectedPaymentMethod:props.data.payForm,
                                    selectedCard:null,}} 
                                dateToBay={props.start} 
                                users={users}
                                usersParticipant={usersParticipant}
                                coursesHeadings={courseHeadingFull}
                                payZero={{ paymentPositionPriceDiscount:paymentPositionPriceDiscount,
                                    paymentPositionPrice:paymentPositionPrice}}
                                    numberOfinstallments={props.data.installment?.length}
                                entryFee={{
                                    discountCash:0,
                                      discountProcent: 0,
                                      paymentData: props.start,
                                      priceCash:props.entryFee,
                                      priceDiscount: props.entryFee,
  
                                  }}
                                allInstallments={props.data.installment}
                                selectedInstallments={props.data.listOfInstallment}
                                allInstallmentsPrice={allInstallmentsPrice}
                                promotionsData={props.data.promotionData}
                            />
          </div>
          <div className={showSchelude?'dont_Display':""} id='elem3'>
                             <AppContractSchedule
                                getGroup={props.data.getGroup} 
                                payForm={{selectedPaymentMethod:props.data.payForm,
                                    selectedCard:null}} 
                                dateToBay={props.start} 
                                users={users}
                                usersParticipant={usersParticipant}
                                coursesHeadings={courseHeadingFull}                            
                                 payZero={{ paymentPositionPriceDiscount:paymentPositionPriceDiscount,
                                    paymentPositionPrice:paymentPositionPrice}}
                                    
                                numberOfinstallments={props.data.installment?.length}
                                entryFee={{
                                    discountCash:0,
                                      discountProcent: 0,
                                      paymentData: props.start,
                                      priceCash:props.entryFee,
                                      priceDiscount: props.entryFee,
  
                                  }}
                                  allInstallments={props.data.installment}
                                  selectedInstallments={props.data.listOfInstallment}
                                allInstallmentsPrice={allInstallmentsPrice}
                                promotionsData={{promotionId:props.data.promotionData.selectedPromotions,
                                    combinedPromotionIDs:[]}}
                            />
                                </div>
    
    </div>:<ComplateData setNavigator={()=>{setIsFullData(true)}} userData={userDataCheck} parcipientData={parcipientNameDataCheck}></ComplateData>}
    
    </>;
    }

export default Contract;
